<template>
    <div class="ownArchives">
        <common-title titleName="我的档案" :isAPPShow="true">
            <div slot="btnSty">
                <div class="hrefBtn" @click="modify">修改档案</div>
            </div>
        </common-title>
        <ArchivesInfo :info="archivesInfo" />
        <Loading ref="loading"/>
    </div>
</template>
<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import Loading from '@/components/loading/loading.vue';
import { getArchivesInfoApi } from '@/api/archives';
import ArchivesInfo from './components/archivesInfo.vue';

export default {
  data() {
    return {
      archivesInfo: null,
    };
  },
  components: {
    CommonTitle,
    ArchivesInfo,
    Loading,
  },
  methods: {
    async getArchivesInfo() {
      this.$refs.loading.show = true;
      const data = await getArchivesInfoApi();
      if (data.code === 0) {
        this.archivesInfo = data.data;
      } else {
        this.$toast.fail(data.msg);
      }
      this.$refs.loading.show = false;
    },
    modify() {
      this.$router.push({ path: '/archives', query: { back: 'back' } });
    },
  },
  mounted() {
    this.getArchivesInfo();
  },
};
</script>
<style lang="scss" scoped>
.ownArchives {
  min-height: 100vh;
  padding: 100px 0 150px;
  background: #fff;
  .hrefBtn {
    position: absolute;
    top: 0;
    right: 36px;
    color: #333;
    font-size: 25px;
  }
}
</style>
